import styled from "styled-components";
import { black, mainFont } from "../../utils/StyleHelpers";

export const StyledPagination = styled.div<any>`
  display: flex;
  align-items: center;
  gap: 2.5rem;
  width: 80.13rem;
  justify-content: right;
  margin-right: ${(props) => (props.marginright ? props.marginright : "")};
`;

export const StyledPageTextWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const StyledPageText = styled.span`
  color: ${black};
  text-align: center;
  font-family: ${mainFont};
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;
